import { Outlet } from 'react-router-dom';
import { Toaster } from '../components/Toaster';

export function GuestLayout() {
  return (
    <div className="min-h-screen bg-muted/30 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="mb-8 flex items-center justify-center gap-3">
          <img src="/logo-icon.svg" alt="" className="h-16 w-16" />
          <img src="/logo-wordmark.svg" alt="Nithi Trade" className="h-14 dark:brightness-0 dark:invert" />
        </div>
        <Outlet />
      </div>
      <Toaster />
    </div>
  );
}
